<div class="space-y-2 w-full md:w-auto text-gray-500">
  <!-- Welcome (always clickable) -->
  <div
    class="cursor-pointer flex items-center gap-3 px-4 py-3 rounded-xl transition-colors flex-1 bg-green-50 text-green-600"
    (click)="selectedNavPage(0)"
  >
    <div
      class="flex items-center justify-center w-8 h-8 rounded-full shrink-0 text-green-600"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M3 9.75L12 3l9 6.75V21a.75.75 0 01-.75.75h-5.25a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75v4.5a.75.75 0 01-.75.75H3.75A.75.75 0 013 21V9.75z"></path>
      </svg>
    </div>
    <span class="font-medium font-['Outfit-medium']">Welcome</span>
  </div>

  <div *ngFor="let step of stepsList; let i = index" (click)="selectedNavPage(i + 1)"
    [ngClass]="{
      'bg-blue-50 text-blue-600 cursor-pointer': _applyJobStepperStatusService.jobSteps[i + 1].isActive,
      'bg-green-50 text-green-600 cursor-pointer': _applyJobStepperStatusService.jobSteps[i + 1].isValid,
      'hover:bg-gray-50': !_applyJobStepperStatusService.jobSteps[i + 1].isValid
    }"
    class="flex items-center gap-3 px-4 py-3 rounded-xl transition-colors flex-1"
  >
    <div
      class="flex items-center justify-center w-8 h-8 rounded-full shrink-0"
    >
      <div [innerHTML]="step.icon" class="cursor-move"></div>
    </div>
    <span class="font-medium font-['Outfit-medium']">{{ step.name }}</span>
  </div>
</div>